import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ChevronRightIcon, FileTextIcon, ShieldCheckIcon, SparklesIcon, WalletIcon } from 'lucide-react';
export type PanelId = 'consentements' | 'factures' | 'confidentialite' | 'atna';
interface Entry {
  id: PanelId | 'notifications';
  title: string;
  description: string;
  icon: typeof BellIcon;
  to?: string;
}
const entries: Entry[] = [{
  id: 'notifications',
  title: 'Notifications',
  description: 'Gérez vos préférences de communication',
  icon: BellIcon,
  to: '/notifications/parametres'
}, {
  id: 'consentements',
  title: 'Consentements',
  description: 'Gérez vos consentements et autorisations',
  icon: ShieldCheckIcon
}, {
  id: 'factures',
  title: 'Mes factures',
  description: 'Consultez vos factures et paiements',
  icon: WalletIcon
}, {
  id: 'confidentialite',
  title: 'Confidentialité et transparence',
  description: 'Comprenez comment vos données et l’IA sont utilisées',
  icon: FileTextIcon
}, {
  id: 'atna',
  title: 'Aide ATNA',
  description: 'Posez une question ou obtenez de l’aide',
  icon: SparklesIcon
}];
interface AccountNavProps {
  onOpen: (panel: PanelId) => void;
}
export function AccountNav({
  onOpen
}: AccountNavProps) {
  return <section aria-labelledby="compte-titre" data-id="element-1804" data-mp="3rrqhwaqm196">
      <h2 id="compte-titre" className="text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-1805" data-mp="3px22809br0c">
        Gérer mon compte
      </h2>
      <ul className="mt-3 space-y-2" data-id="element-1806" data-mp="386hnnentayk9">
        {entries.map(entry => {
        const shared = 'group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo';
        const inner = <>
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy transition-colors duration-150 ease-ville group-hover:bg-ville-indigo-soft group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1807" data-mp="2ois5lz5ogco8">
                <entry.icon className="h-5 w-5" data-id="element-1808" data-mp="1255lhxx0awgo" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-1809" data-mp="12707lfk0kumc">
                <span className="block text-[15px] font-bold text-ville-navy" data-id="element-1810" data-mp="1749t4k4a8m4w">{entry.title}</span>
                <span className="block text-sm leading-snug text-slate-500" data-id="element-1811" data-mp="9h1dv6uvk9bc">{entry.description}</span>
              </span>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1812" data-mp="eg49y1svn576" />
            </>;
        return <li key={entry.id} data-id="element-1813" data-mp="1utuo61dpn9uj">
              {entry.to ? <Link to={entry.to} className={shared} data-id="element-1814" data-mp="1uvnmmte66nrg">
                  {inner}
                </Link> : <button type="button" onClick={() => onOpen(entry.id as PanelId)} className={shared} data-id="element-1815" data-mp="3jd784f8rtk0b">
                  {inner}
                </button>}
            </li>;
      })}
      </ul>
    </section>;
}